module.exports = __webpack_public_path__ + "media/images/products/retailers-og-5-b904e308e7c8ff7631e525dbcbe9cb2f.jpg";